import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("I am ElButton")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Vue logo",
  src: _imports_0
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_HelloWorld = _resolveComponent("HelloWorld")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, null, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _hoisted_3,
    _createVNode(_component_HelloWorld, { msg: "Welcome to Your Vue.js + TypeScript App" })
  ]))
}